import React from "react";
import "./Forbidden.css";

export default () =>
    <div className="Forbidden">
        <h3>errortest!</h3>
    </div>;
